module.exports = __webpack_public_path__ + "static/media/01.32702c7e.png";